import { render } from "./FormStaff.vue?vue&type=template&id=7bb5523c&scoped=true&ts=true"
import script from "./FormStaff.vue?vue&type=script&lang=ts"
export * from "./FormStaff.vue?vue&type=script&lang=ts"

import "./FormStaff.vue?vue&type=style&index=0&id=7bb5523c&scoped=true&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb5523c"]])

export default __exports__